export default {
  form: {
    shipping_company_name: {
      label: 'Bedrijf',
      placeholder: 'Bedrijfsnaam invoeren',
    },
    shipping_phone_number: {
      label: 'Telefoonnummer',
      placeholder: 'Telefoonnummer invoeren',
    },
    shipping_salutation: {
      label: 'Aanhef',
      options: {
        mr: 'Dhr.',
        mrs: 'Mevr.',
      },
    },
    shipping_first_name: {
      label: 'Voornaam',
      placeholder: 'Voornaam invoeren',
    },
    shipping_last_name: {
      label: 'Achternaam',
      placeholder: 'Achternaam invoeren',
    },
  },
  buttons: {
    back: 'Terug',
    next: 'Volgende',
  },
};
